/**
 * @file texts for post moderation values
 * should match values in app/services/notifications/moderatable_post_added.rb
 */
import { __ } from '@@/bits/intl'
import { ModerationCategories } from '@@/enums'

function postModerationWarningText({
  moderationViolations,
  useLongText,
}: {
  moderationViolations?: ModerationCategories[]
  useLongText: boolean
}): string {
  if (moderationViolations == null || moderationViolations.length === 0) {
    return ''
  }

  if (moderationViolations.length > 1) {
    return useLongText
      ? __('Warning: this post may contain inappropriate content.')
      : __('This post may contain inappropriate content.')
  }

  const singleViolation = moderationViolations[0]
  switch (singleViolation) {
    case ModerationCategories.Sexual:
      return useLongText
        ? __('Warning: this post may contain sexual content.')
        : __('This post may contain sexual content.')
    case ModerationCategories.Hate:
      return useLongText
        ? __('Warning: this post may contain hateful content.')
        : __('This post may contain hateful content.')
    case ModerationCategories.Violence:
      return useLongText
        ? __('Warning: this post may contain violent content.')
        : __('This post may contain violent content.')
    case ModerationCategories.Bullying:
      return useLongText ? __('Warning: this post may contain bullying.') : __('This post may contain bullying.')
    case ModerationCategories.Weapons:
      return useLongText
        ? __('Warning: this post may contain content relating to weapons.')
        : __('This post may contain content relating to weapons.')
    case ModerationCategories.ChildExploitation:
      return useLongText
        ? __('Warning: this post may contain content relating to child exploitation.')
        : __('This post may contain content relating to child exploitation.')
    case ModerationCategories.ChildSafety:
      return useLongText
        ? __('Warning: this post may contain content relating to child safety.')
        : __('This post may contain content relating to child safety.')
    case ModerationCategories.SelfHarm:
      return useLongText
        ? __('Warning: this post may contain content relating to self harm.')
        : __('This post may contain content relating to self harm.')
    case ModerationCategories.Profanity:
      return useLongText ? __('Warning: this post may contain profanity.') : __('This post may contain profanity.')
    case ModerationCategories.Drugs:
      return useLongText
        ? __('Warning: this post may contain content relating to drugs.')
        : __('This post may contain content relating to drugs.')
    default:
      return useLongText
        ? __('Warning: this post may contain inappropriate content.')
        : __('This post may contain inappropriate content.')
  }
}

export { postModerationWarningText }
